import React, { forwardRef } from 'react';

import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';

import { useSearchPageTranslation } from '../../../../i18n';

function TopSimilarObjectsFilterPopover(
  {
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useSearchPageTranslation();
  const { register, formState: { errors } } = useFormContext();

  return (
    <FilterPopover
      {...props}
      name="top_similar_object_ids"
      ref={ref}
      title={<div className="Body-2">{t('filters.event_filters.comparing_attributes.top_similar_objects')}</div>}
    >
      <Control.Input
        id="top_similar_object_ids"
        {...register('top_similar_object_ids', { validate: validate.multipleUuid() })}
        errors={errors}
      />
    </FilterPopover>
  );
}

const TopSimilarObjectsFilterPopoverWithRef = forwardRef(TopSimilarObjectsFilterPopover);
export { TopSimilarObjectsFilterPopoverWithRef as TopSimilarObjectsFilterPopover };
